import { useTranslation } from 'react-i18next';

interface FunnelStep {
  labelKey: string;
  count: number;
  max: number;
  pct?: number;
  pctLabelKey?: string;
}

interface FunnelBarProps {
  steps: FunnelStep[];
}

/**
 * Horizontal progress-bar funnel. Each step shows a labelled bar + optional
 * conversion % annotation. Uses role="progressbar" (F031 DashboardPage pattern).
 */
export function FunnelBar({ steps }: FunnelBarProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-3">
      {steps.map((step) => (
        <div key={step.labelKey} className="space-y-1">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">{t(step.labelKey)}</span>
            <span className="font-medium tabular-nums">{step.count}</span>
          </div>
          <div className="h-2 w-full rounded-full bg-muted overflow-hidden">
            <div
              role="progressbar"
              aria-valuenow={step.count}
              aria-valuemin={0}
              aria-valuemax={step.max}
              className="h-full rounded-full bg-foreground transition-all"
              style={{ width: step.max > 0 ? `${(step.count / step.max) * 100}%` : '0%' }}
            />
          </div>
          {step.pct !== undefined && step.pctLabelKey ? (
            <p className="text-xs text-muted-foreground">
              {t(step.pctLabelKey)}: {step.pct}%
            </p>
          ) : null}
        </div>
      ))}
    </div>
  );
}
